/* eslint-disable import/no-unused-modules */
import { useQuery } from '@apollo/client';
import LinearProgress from '@mui/material/LinearProgress';
import dynamic from 'next/dynamic';
import React from 'react';
import { GET_GEOJSON } from '../../helpers/graphql/geojson';
import BlogTab from './BlogTab';
import TabPanel from './TabPanel';

const MapTab = dynamic(() => import('./MapTab'), {
  ssr: false,
  loading: () => <LinearProgress />,
});

export default function ProfileTabs({
  value,
  countryCodes,
  userPosts,
  profile,
  itineraries,
  isMini,
}) {
  const { data } = useQuery(GET_GEOJSON, {
    variables: { countryList: countryCodes },
  });

  return (
    <>
      <TabPanel value={value} index={0}>
        <BlogTab profile={profile} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        {value === 1 && data && data.geojson && (
          <MapTab geojson={data.geojson} posts={userPosts} isMini={isMini} />
        )}
      </TabPanel>
      {itineraries && itineraries.length > 0 && (
        <TabPanel value={value} index={2}>
          <BlogTab profile={profile} itineraries={itineraries} />
        </TabPanel>
      )}
    </>
  );
}
